
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import {
  getAbandonReasonList,
  addAbandonReasonList,
} from '@/api/task/antOrderReview'
import addAccount from './addAccount.vue'
import { delObjEmptyKey, parseTime } from '@/utils'

@Component({
  name: 'AccountList',
  components: {
    addAccount,
  },
  filters: {
    parseTime(date) {
      return parseTime(date, '{y}-{m}-{d} {h}:{i}:{s}')
    },
  },
})
export default class extends Vue {
  private listLoading: boolean = false
  private list: any = []
  private total = 0

  private back() {
    this.$emit('close')
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.onloadAbandonReasonList()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.onloadAbandonReasonList()
  }

  private async onloadAbandonReasonList() {
    try {
      this.listLoading = true
      // delObjEmptyKey(data)
      await getAbandonReasonList().then((res: any) => {
        this.list = res.results
        this.total = res.count
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  private addVisible: boolean = false
  private openAdd() {
    this.addVisible = true
  }
  private closeAdd() {
    this.addVisible = false
    this.onloadAbandonReasonList()
  }
  mounted() {}
}
